import { AppProps } from '../../../App';
import { PageTitle } from '../../../components/PageTitle';
import { EvaluateForm } from './components/EvaluateForm';

const CU05602Page = (props: AppProps) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-056-02-container"
        >
            <PageTitle title="かんたん査定" />
            <section className="center-inside h-full w-full">
                <div className="center-item w-full md:w-full">
                    <EvaluateForm {...props} />
                </div>
            </section>
        </div>
    );
};

export default CU05602Page;
